import { CommonUtilsService } from '../../services/commonutils/common-utils.service';
import { createReducer, on } from '@ngrx/store';

import { PermissionsObject } from '../../interface/permissions.interface';
import { SessionLogoutSuccessfull } from '../actions';
import * as actions from '../actions/permissions.actions';
import { permissionsState } from '../states';

export const PERMISSIONS_REDUCER_KEY = 'permissions';

export const PERMISSIONS_REDUCER = createReducer(
    permissionsState,
    on(actions.SetPermissionsByTypes, (state, action) => {
        const existingPermissions =
            CommonUtilsService.cloneObject(state?.organizationsMap?.[action.currentOrganizationId]?.sessionUserPermissions) ||
            ({} as PermissionsObject);
        Object.keys(action.permissions).forEach(key => {
            if (existingPermissions?.[key]) {
                existingPermissions[key] = {
                    ...existingPermissions[key],
                    ...action.permissions[key],
                };
            } else {
                existingPermissions[key] = action.permissions[key];
            }
        });
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [action.currentOrganizationId]: {
                    ...state.organizationsMap?.[action.currentOrganizationId],
                    sessionUserPermissions: existingPermissions,
                },
            },
        };
    }),
    on(actions.SetBundlePermissions, (state, action) => {
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [action.organizationId]: {
                    ...state.organizationsMap?.[action.organizationId],
                    bundlesMap: {
                        ...state.organizationsMap?.[action.organizationId]?.bundlesMap,
                        [action.bundleId]: {
                            ...state.organizationsMap?.[action.organizationId]?.bundlesMap?.[action.bundleId],
                            bundlePermissions: action.permissions,
                        },
                    },
                },
            },
        };
    }),
    on(actions.SetBundleRolePermissions, (state, action) => {
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [action.organizationId]: {
                    ...state.organizationsMap?.[action.organizationId],
                    bundlesMap: {
                        ...state.organizationsMap?.[action.organizationId]?.bundlesMap,
                        [action.bundleId]: {
                            ...state.organizationsMap?.[action.organizationId]?.bundlesMap?.[action.bundleId],
                            bundleRolePermissions: {
                                ...state.organizationsMap?.[action.organizationId]?.bundlesMap?.[action.bundleId]?.bundleRolePermissions,
                                [action.roleId]: action.rolePermissions,
                            },
                        },
                    },
                },
            },
        };
    }),
    on(actions.SetRolePermissions, (state, action) => {
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [action.organizationId]: {
                    ...state.organizationsMap?.[action.organizationId],
                    rolePermissions: {
                        ...state.organizationsMap?.[action.organizationId]?.rolePermissions,
                        [action.roleId]: action.rolePermissions,
                    },
                },
            },
        };
    }),

    on(actions.SetAllRolePermissions, (state, action) => {
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [action.organizationId]: {
                    ...state.organizationsMap?.[action.organizationId],
                    allRolePermissions: action.permissions,
                },
            },
        };
    }),
    on(SessionLogoutSuccessfull, () => permissionsState)
);
